import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ChakraProvider } from '@chakra-ui/react';
import { datadogRum } from '@datadog/browser-rum';

import SecurityGate from 'Component/security-guard';
import RegisterServiceWorker from 'Component/register-service-worker';
import PreventTabClose from 'Component/prevent-tab-close';
import ServerSentEvent from 'Component/serve-sent-event';
import FaceModelLoader from 'Component/face-model-loader';
import Router from 'Route';

import 'Style/index.scss';
function App() {
  const queryClient = new QueryClient();

  return (
    <div className="App">
      <FaceModelLoader />
      <QueryClientProvider client={queryClient}>
        <ChakraProvider>
          <ServerSentEvent>
            <SecurityGate>
              <RegisterServiceWorker>
                <PreventTabClose>
                  <Router />
                </PreventTabClose>
              </RegisterServiceWorker>
            </SecurityGate>
          </ServerSentEvent>
        </ChakraProvider>
        <ReactQueryDevtools initialIsOpen={true} />
      </QueryClientProvider>
    </div>
  );
}

if (process.env.REACT_APP_ENV === 'production') {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'ap1.datadoghq.com',
    service: 'livestream-web-ui',
    env: 'production',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 50,
    defaultPrivacyLevel: 'mask-user-input',
  });
}
export default App;
